import React from 'react';

import makeClasses from './SODetailSkeleton.style';

export function SODetailSkeleton() {
  const classes = makeClasses();

  return (
    <div className={classes.layout} aria-hidden='true'>
      <div className={classes.productsArea}>
        <div className={classes.headerTitle} />
        <div className={classes.headerTag} />
        <div className={classes.headerCount} />
        <div className={classes.alert} />
        <div className={`${classes.productLine} ${classes.productLineLong}`} />
        <div className={`${classes.productLine} ${classes.productLineShort}`} />
        <div className={`${classes.productLine} ${classes.productLineLong}`} />
        <div className={`${classes.productLine} ${classes.productLineShort}`} />
      </div>

      <div className={classes.totalArea}>
        <div className={classes.totalRow}>
          <div className={classes.totalLabel} />
          <div className={classes.totalAmount} />
        </div>
      </div>

      <div className={classes.mainArea}>
        <div className={classes.clientCard}>
          <div className={classes.clientLabel} />
          <div className={classes.clientName} />
        </div>
        <div className={classes.illustration} />
        <div className={classes.bannerText} />
      </div>
    </div>
  );
}
